import React, { FC, useEffect, useState } from "react";
import { usePageSize } from "../../hooks";
import { useStore } from "effector-react";
import { $countdown } from "../../store/shared/countdown";
import cn from "classnames";
import stl from "./index.module.scss";
import BookingDetails, { CountdownRender } from "../BookingDetails";
import { Modal } from "../../components";

const BookingDetailsMobile: FC = () => {
  const pageSize = usePageSize();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  useEffect(() => {
    let on = true;
    if (on) setIsOpen(pageSize.md);
    return () => {
      on = false;
    };
  }, [pageSize.md]);

  return (
    <div className={stl.block}>
      <TopLineRender isOpen={isOpen} onSelect={() => setIsOpen(!isOpen)} />
      <Modal visible={isOpen} onClose={() => setIsOpen(false)}>
        <BookingDetails />
      </Modal>
    </div>
  );
};

export default BookingDetailsMobile;

const TopLineRender: FC<{ onSelect: () => void; isOpen: boolean }> = ({
  onSelect,
  isOpen,
}) => {
  const countdown = useStore($countdown);

  if (!countdown.enabled) return null;

  return (
    <button
      className={cn(stl.top, stl.topCollapsible, {
        [stl.topCollapsibleOpen]: isOpen,
      })}
      onClick={() => onSelect?.()}
    >
      <CountdownRender />
    </button>
  );
};
